<template>
  <div class="footer legal-footer-padding">
    <a :href="url" class="company">{{ name }}</a>
      <div class="address">{{ address }}</div>
      <div class="contact">{{ contact }}</div>
    <a href="/#/legal" class="terms" :style="{ 'color': primaryColor }">{{ term }}</a>
  </div>
</template>

<script>
  import main from './Company.js'
  export default main
</script>

<style lang="scss" scoped>
  @import '../variable.scss';
  @import './Company.scss';
</style>



// WEBPACK FOOTER //
// Company.vue?f52d235a